{
  "title": "Arcane Eye",
  "source": "Player's Handbook",
  "levelAndSchool": "4th-level divination",
  "level": 4,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S, M (a bit of bat fur)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You create an invisible, magical eye within range that hovers in the air for the duration. You mentally receive visual information from the eye, which has normal vision and darkvision out to 30 feet. The eye can look in every direction.",
    "As an action, you can move the eye up to 30 feet in any direction. There is no limit to how far away from you the eye can move, but it can’t enter another plane of existence. A solid barrier blocks the eye’s movement, but the eye can pass through an opening as small as 1 inch in diameter."
  ],
  "spellLists": ["artificer", "wizard"]
}
